import { Component } from '@angular/core';

@Component({
  selector: 'app-document-order-icon',
  imports: [],
  templateUrl: './document-order-icon.html',
  styleUrl: './document-order-icon.scss',
})
export class DocumentOrderIcon {

}
